import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function HourGlassIcon(props) {
  const {
    style,
    color = "#2D3142",
    width = 20,
    height = 20,
    onPress = () => {},
  } = props;

  return (
    <TouchableOpacity style={[style]} onPress={onPress}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_hours)">
          <Path
            d="M11.8731 10.5491V10.4671C11.8727 10.3581 11.9013 10.251 11.9561 10.1567C12.0108 10.0624 12.0896 9.98432 12.1844 9.93054C13.7204 9.09083 14.2775 7.06325 14.4782 5.61732C14.5064 5.41948 14.4917 5.2179 14.4353 5.0262C14.3788 4.83451 14.2819 4.65715 14.1511 4.50612C14.0202 4.35508 13.8585 4.23388 13.6768 4.15069C13.4951 4.06751 13.2977 4.02428 13.0978 4.02393H7.42471C7.22506 4.02369 7.0277 4.06638 6.846 4.1491C6.6643 4.23182 6.50251 4.35264 6.3716 4.50336C6.24068 4.65409 6.1437 4.8312 6.08723 5.02269C6.03077 5.21419 6.01613 5.41558 6.04431 5.61322C6.22864 7.03867 6.78162 9.03758 8.2767 9.89777C8.38881 9.96153 8.482 10.0539 8.54677 10.1654C8.61153 10.277 8.64555 10.4037 8.64535 10.5327V10.5327C8.64535 10.6805 8.60538 10.8255 8.52966 10.9524C8.45394 11.0793 8.34531 11.1834 8.21526 11.2536C6.75294 12.081 6.22864 14.0185 6.03612 15.4111C6.01103 15.6074 6.02815 15.8067 6.08634 15.9958C6.14453 16.1848 6.24246 16.3593 6.37355 16.5075C6.50464 16.6556 6.66587 16.774 6.84645 16.8548C7.02703 16.9356 7.22279 16.9769 7.42061 16.9759H13.0937C13.2948 16.9753 13.4934 16.9313 13.6759 16.8468C13.8584 16.7624 14.0206 16.6396 14.1513 16.4868C14.2819 16.3339 14.3781 16.1547 14.4331 15.9613C14.4881 15.7678 14.5007 15.5648 14.47 15.3661C14.2693 13.9939 13.7327 12.0892 12.2868 11.27C12.1598 11.1976 12.0545 11.0926 11.9817 10.9659C11.909 10.8391 11.8715 10.6952 11.8731 10.5491Z"
            stroke={color}
            strokeWidth="2.04806"
            strokeMiterlimit="10"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_hours">
            <Rect
              width="10.5147"
              height="15"
              fill="white"
              transform="translate(5 3)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
